import { Helper } from "../../core/util/helper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { AppHelper } from "../../appHelper";
import { AppBaseProps, CommonApp, Context, Entity } from "../../core/components/commonApp";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { KeyValuePair } from "../../commonInterfaces";
import React from "react";

export default class EditCode extends React.Component<EditCodeProps, any>{
    common = new AppHelper();
    _translations: {};

    constructor(props) {
        super(props);
        this.common.init(this);
        this._setEvents();
        const gridOptions: {} = this._getMetaData("translationsGridOptions");
        this._translations = this._getMetaData("translations");
        this.props.context.translationsGridOptions = gridOptions;
        this.props.context.translations = this._translations;
    }

    private _getMetaData = (name: string) => {
        const objects = this.props.metadata.additional.objects;
        for (let i = 0; i < objects.length; i++) {
            if (objects[i].name == name) {
                return objects[i].data;
            }
        }
    }

    private _checkEntity = () => {
        const translations = this.props.entity.Translations;
        if (Helper.hasValue(translations)) {
            for (let i = 0; i < translations.length; i++) {
                if (!Helper.isNullOrEmpty(translations[i].Value))
                    return true;
            }
        }
        NotificationHelper.showErrorMessage(this._translations["WebSMS.UserSettings.MainGroup.FillAllLanguages"]);
        return false;


        //console.log(this.props.entity)
        //if (!Helper.isNullOrEmpty(this.props.entity.Name)) {
        //    return true;
        //} else {
        //    for (let i = 0; i < this.props.entity.LanguageDependentParameters.length; i++) {
        //        if (Helper.hasValue(this.props.entity.LanguageDependentParameters[i].Name)) {
        //            return true;
        //        }
        //    }
        //    return false;
        //}
    }

    save = (closeAfterSave) => {
        if (this._checkEntity()) {
            if (this.common.validate()) {
                HTTPService.post<JsonResultClass>("Code/SaveCode", this.props.entity)
                    .then((result) => {
                        if (result.Code === 0) {
                            this.props.entity.IsNew = false;
                            NotificationHelper.showSuccessMessage(result.Message);
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                        this.common.handlePostSave(result.Code === 0, closeAfterSave);
                        this.setState({});
                    });
            }
        } 
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit) {
            this.common.handleFieldChange(field, value, dataItem);
        }
    }

    private _setEvents = () => {
        $(window).on("CodeEntityChanged", (e, d) => {
            if (d.update) {
                this.common.setEntityDirtyState(true);
            }
        });
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

export interface EditCodeProps extends AppBaseProps {
    entity: CodeEntity;
    context: CodeContext;
}

interface CodeContext extends Context {
    translationsGridOptions?: {};
    translations?: {};
}


export interface CodeEntity extends Entity {
    KNr: number;
    Name: string;
    //LanguageDependentParameters: CodeLanguageDependentParameters[];
    Translations: KeyValuePair<number, string>[];
}

export interface CodeLanguageDependentParameters {
    Name: string;
    Language: LanguageIdx;
}

export interface LanguageIdx {
    Id: number;
    LanguageName: string;
}